// utils/validation.js
export const isValidValue = (value) => {
  if (value === null || value === undefined) return false;
  if (typeof value === "string" && !value.trim()) return false; // empty string
  if (value === "null" || value === "undefined" || value === "NaN") return false;
  if (typeof value === "number" && isNaN(value)) return false;
  return true;
};
